var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("redeem_coupon_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('redeem_coupon_page.form_desc'))
    }
  }), _vm.getModuleConfig('redeem_coupon_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('redeem_coupon_page.content'))
    }
  }) : _vm._e(), _vm.$route.params.coupon_hashid ? _c('coupon-filters', {
    staticClass: "s-mb-3",
    attrs: {
      "options": _vm.filterOptions
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "pointes-list"
  }, [_vm._l(_vm.coupons, function (item) {
    return _c('PointCard', {
      key: item.id,
      attrs: {
        "item": item,
        "show-preview-button": true
      },
      on: {
        "exchange": _vm.handleExchange,
        "preview": _vm.handlePreviewCoupon
      }
    });
  }), _vm.filter === 'all' ? _c('PointPagination', {
    attrs: {
      "totalPage": _vm.totalPage
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }) : _vm._e(), _c('Popup', {
    ref: "popupUsage",
    attrs: {
      "panelHeight": "auto"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" 是否確定要使用 "), _c('span', {
    staticClass: "s-primary"
  }, [_vm._v(_vm._s(_vm.currentCoupon.point.toLocaleString()))]), _vm._v(" 點 ")]), _vm.branchCode ? _c('div', {
    staticClass: "s-mb-5 s-text-center"
  }, [_vm._v(" 兌換店號：" + _vm._s(_vm.branchCode) + " ")]) : _vm._e(), _c('div', {
    staticClass: "s-mt-5 s-mb-5 s-text-center"
  }, [_vm._v(" 請注意，點數一經使用即無法取消 ")]), _c('div', {
    staticClass: "s-flex s-space-x-2",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.popupUsage.close();
      }
    }
  }, [_vm._v(" 取消 ")]), _c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v(" 確定 ")])])]), _c('Popup', {
    ref: "popupBranchCode",
    attrs: {
      "panelHeight": "auto"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("請輸入店號")]), _c('div', {
    staticClass: "s-mb-5 s-text-center"
  }, [_vm._v(" 請輸入店號以完成兌換 ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.branchCode,
      expression: "branchCode"
    }],
    staticClass: "s-mb-5 s-text-center branch-code-input",
    attrs: {
      "placeholder": "請輸入店號"
    },
    domProps: {
      "value": _vm.branchCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.branchCode = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "s-flex s-space-x-2",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.popupBranchCode.close();
      }
    }
  }, [_vm._v(" 取消 ")]), _c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.branchCode
    },
    on: {
      "click": _vm.handleBranchCodeConfirm
    }
  }, [_vm._v(" 確定 ")])])])], 2), _c('coupon-modal', {
    ref: "couponModal",
    attrs: {
      "coupon": _vm.immediateUsageCoupon
    }
  }), _c('coupon-modal', {
    ref: "tempCouponModal",
    attrs: {
      "redeem-code-bundle-id": _vm.currentCoupon.id,
      "confirm-from-outside": true
    },
    on: {
      "confirmFromOutside": _vm.confirmFromOutside
    }
  }), _c('coupon-modal', {
    ref: "previewCouponModal",
    attrs: {
      "preview-mode": true,
      "redeem-code-bundle-id": _vm.currentCoupon.id
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }